import { injectable, inject } from 'inversify';
import type { ISupportTicketRepository, SupportTicketDTO } from '@/domain/repositories/ISupportTicketRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListTicketsAction {
  constructor(
    @inject(TYPES.ISupportTicketRepository) private repo: ISupportTicketRepository
  ) {}

  async execute(tenantId?: string): Promise<SupportTicketDTO[]> {
    return this.repo.getAll(tenantId);
  }
}
